var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.018 11.666.315-1.133a2.201 2.201 0 0 0-1.19-2.585.147.147 0 0 1-.076-.184l1.972-5.35a.2.2 0 0 0-.103-.25l-1.48-.69a.2.2 0 0 0-.257.082l-2.83 4.95a.147.147 0 0 1-.19.06 2.201 2.201 0 0 0-2.746.75l-.665.97m7.25 3.38-7.25-3.38m7.25 3.38-3.25 6.968a.5.5 0 0 1-.443.289l-2.302.046a.5.5 0 0 1-.48-.671l1.141-3.133c.04-.107-.102-.186-.172-.096l-2.298 2.923a.5.5 0 0 1-.662.113L4.684 16.91a.5.5 0 0 1-.135-.716l1.916-2.622c.066-.09-.042-.203-.135-.143l-2.918 1.896a.5.5 0 0 1-.61-.05l-1.349-1.238a1 1 0 0 1 .116-1.566l6.199-4.186",
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroom);
export default __webpack_public_path__ + "static/media/Broom.9394f5f29f0381e6fcd5ac408db1c8b1.svg";
export { ForwardRef as ReactComponent };